import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
/*import ScrollIndicator from './components/ScrollIndicator';*/
import WhatsAppCTA from './components/WhatsAppCTA';
import ScrollToTopRoute from './components/ScrollTopRoute';
import About from './pages/About';
import Contact from './pages/Contact';
import Home3 from './pages/Home3';
import Projects from './pages/Projects';

function App() {
    return (
        <>
            <Router>
                <ScrollToTopRoute />
                <Routes>
                    <Route path="/" element={<Home3 />} />
                    <Route path="/about" element={<About />} />
                    <Route path="/contact" element={<Contact />} />
                    <Route path="/gallery" element={<Projects />} />
                    {/*<Route path="/home-2" element={<Home2 />} />
                    <Route path="/team" element={<Team />} />
                    <Route path="/faq" element={<Faq />} />
                    <Route path="/services" element={<Services />} />
                    <Route path="/services-details" element={<ServicesDetails />} />
                    <Route path="/project-details" element={<ProjectDetails />} />
                    <Route path="/news" element={<News />} />
                    <Route path="/news-details" element={<NewsDetails />} />
                    <Route path="/home-1" element={<Home1 />} />*/}
                </Routes>
            </Router>
            {/*<ScrollIndicator />*/}
            <WhatsAppCTA />
        </>
    );
}

export default App;
